import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acMobileSubscription" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1a",
      d: "M54 289.8l-4.8-4.8-4.9 4.8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1b",
      d: "M41.3 288.6c-1.5 1.7-2.3 3.9-2.3 6.3 0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.4-.8-4.6-2.3-6.3"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1c",
      d: "M49.2 285v11"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", { transform: "translate(-38 -284)" }, [
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#0E2242",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1a"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#0E2242",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1b"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#0E2242",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1c"
        })
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "acMobileSubscription_body" }
const _hoisted_4 = { class: "acMobileSubscription_text -black" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1a",
      d: "M54 289.8l-4.8-4.8-4.9 4.8"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1b",
      d: "M41.3 288.6c-1.5 1.7-2.3 3.9-2.3 6.3 0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.4-.8-4.6-2.3-6.3"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "2jg1c",
      d: "M49.2 285v11"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", { transform: "translate(-38 -284)" }, [
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#fff",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1a"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#fff",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1b"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("use", {
          fill: "#fff",
          "fill-opacity": "0",
          stroke: "#fff",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-miterlimit": "50",
          "xlink:href": "#2jg1c"
        })
      ])
    ])
  ])
], -1)
const _hoisted_6 = { class: "acMobileSubscription_body" }
const _hoisted_7 = { class: "acMobileSubscription_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_as_header_mobile = _resolveComponent("as-header-mobile")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_header_main = _resolveComponent("as-header-main")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mq_responsive, {
      class: "acMobileSubscription_wrapper",
      target: "mobile-tablet"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_header_mobile, {
          title: _ctx.username,
          avatar: _ctx.user.avatar,
          "show-points": ""
        }, {
          menu: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'logout' },
              class: "asHeaderMain_item acMobileSubscription_logout",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": "{ name: 'logout' }",
              "data-analytics-element-id": "-exit",
              "data-analytics-element-name": _ctx.$t('accountExit'),
              title: _ctx.$t('accountExit')
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["data-analytics-element-name", "title"])
          ]),
          _: 1
        }, 8, ["title", "avatar"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_mq_responsive, {
      class: "acMobileSubscription_wrapper lCommon bg-blue",
      target: "desktop"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_header_main, null, {
          menu: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'logout' },
              class: "asHeaderMain_item acMobileSubscription_logout",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": "{ name: 'logout' }",
              "data-analytics-element-id": "-exit",
              "data-analytics-element-name": _ctx.$t('accountExit'),
              title: _ctx.$t('accountExit')
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["data-analytics-element-name", "title"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.text), 1)
        ])
      ]),
      _: 1
    })
  ]))
}